const csvTemplate = `description,market_type,currency,taxes.type,taxes.value,valid_from,valid_to,reference,price
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,AU.SC-SDMTTALL1,400901
Pricelist test 2025,GT,VND,inc,11,01/03/2024,31/12/2024,AU.SC-SDMGTALL1,400901
Pricelist test 2025,GT,VND,inc,12,01/03/2024,31/12/2024,AU.SC-JCMWCALL1,554054
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,RJK.SC-PPEIM251,368469
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,RJK.SC-BPEIM251,431532
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,RJK.SC-FPEIM251,368469
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,CRS.MU-CSSUCT1,121622
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,CRS.SC-CSSUPM81,288288
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,AU.SC-SDMAVALL1,292793
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,AU.SC-JCMSGALL1,350451
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,CX.SC-FFPLAM30ALL1,405405
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,CX.SC-ASPEC251,368469
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,CX.SC-ACCLIM125ALL1,350451
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,RJK.SC-EDSSALLS,355856
Pricelist test 2025,GT,VND,inc,10,01/03/2024,31/12/2024,RJK.BT-HPALLS,121622`;

export default csvTemplate;
